var _path, _path2, _rect, _rect2, _rect3, _path3, _circle, _path4, _path5, _path6, _path7, _path8, _circle2, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 96,
    viewBox: "0 0 242 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.2656 36.7212C65.2656 30.3168 70.4574 25.125 76.8619 25.125H162.521C168.925 25.125 174.117 30.3168 174.117 36.7212V83.1357C174.117 89.5401 168.925 94.7319 162.521 94.7319H76.8618C70.4574 94.7319 65.2656 89.5401 65.2656 83.1357V36.7212Z",
    fill: "white",
    stroke: "#8984FF",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9453 52.4478C72.9453 48.4726 76.1679 45.25 80.1432 45.25H96.7475C100.723 45.25 103.945 48.4726 103.945 52.4478V79.5522C103.945 83.5274 100.723 86.75 96.7475 86.75H80.1432C76.1679 86.75 72.9453 83.5274 72.9453 79.5522V52.4478Z",
    fill: "url(#paint0_linear_2674_28394)",
    stroke: "#8984FF",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 126.945,
    y: 46,
    width: 7,
    height: 16,
    rx: 3.5,
    transform: "rotate(90 126.945 46)",
    fill: "url(#paint1_linear_2674_28394)",
    stroke: "#8984FF",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 141.945,
    y: 59,
    width: 7,
    height: 31,
    rx: 3.5,
    transform: "rotate(90 141.945 59)",
    fill: "url(#paint2_linear_2674_28394)",
    stroke: "#8984FF",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 72.9453,
    y: 32,
    width: 94.8807,
    height: 5.67571,
    rx: 2.83785,
    fill: "#BCB9FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M211.494 94.8476L30 94.8477",
    stroke: "#8984FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 171.664,
    cy: 32,
    r: 18,
    fill: "#85EEB2",
    stroke: "#8984FF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M171.664 24.125L171.664 41",
    stroke: "#8984FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M179.82 32L162.945 32",
    stroke: "#8984FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M110.945 77.8066C110.945 75.0452 113.184 72.8066 115.945 72.8066H155.945C158.707 72.8066 160.945 75.0452 160.945 77.8066V81.7501C160.945 84.5115 158.707 86.75 155.945 86.75H115.945C113.184 86.75 110.945 84.5115 110.945 81.75V77.8066Z",
    fill: "white",
    stroke: "#8984FF",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeDasharray: "1 3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2891 32.5508L49.1969 32.9026L53.9691 33.0566",
    stroke: "#8984FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7656 14L56.5769 19.2535L57.8069 21.5519",
    stroke: "#8984FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.50044,
    cy: 4.50044,
    r: 4.50044,
    transform: "matrix(-1 0 0 1 56.6484 43.4688)",
    fill: "#FFDF70"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M202.188 52.756C202.344 52.6694 202.344 52.4423 202.188 52.3557C198.608 50.3682 195.651 47.4055 193.67 43.8377C193.583 43.6816 193.356 43.6816 193.27 43.8377C191.289 47.4055 188.332 50.3682 184.752 52.3557C184.596 52.4423 184.596 52.6694 184.752 52.756C188.332 54.7434 191.289 57.7062 193.27 61.274C193.356 61.4301 193.583 61.4301 193.67 61.274C195.651 57.7062 198.608 54.7434 202.188 52.756Z",
    fill: "#BCB9FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2674_28394",
    x1: 103.945,
    y1: 92.8864,
    x2: 62.9426,
    y2: 80.5784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.168056,
    stopColor: "#FDCFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDF70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2674_28394",
    x1: 136.278,
    y1: 46,
    x2: 124.716,
    y2: 63.5725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.410576,
    stopColor: "#FDCFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754862,
    stopColor: "#FFDF70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2674_28394",
    x1: 151.278,
    y1: 59,
    x2: 127.587,
    y2: 77.5848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.410576,
    stopColor: "#FDCFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754862,
    stopColor: "#FFDF70"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourses);
export default __webpack_public_path__ + "static/media/courses.7fd2c53a6cc97ff90580f06d6d8add83.svg";
export { ForwardRef as ReactComponent };